<template>
  <app-layout style="padding-top: 0px">
    <div slot="conteudo">
      <v-alert color="blue-grey" style="margin: 0px 5px 5px 5px">
        <h4 style="color: white">Súmulas TCE/MA</h4>
      </v-alert>

      <!-- <v-row style="margin-left: 4px">
        <v-col cols="12" md="3">
          <v-text-field
            v-on:keyup.enter="buscar()"
            label="Processo"
            v-model="filtro.numeroProcesso"
          />
        </v-col>

        <v-col cols="12" md="3">
          <v-text-field
            v-on:keyup.enter="buscar()"
            label="Órgao"
            v-model="filtro.orgao"
          />
        </v-col>

        <v-col md="2">
          <v-text-field
            v-on:keyup.enter="buscar()"
            type="date"
            label="Data Inicio"
            v-model="filtro.inicioSancao"
          />
        </v-col>
        <v-col md="2">
          <v-text-field
            v-on:keyup.enter="buscar()"
            type="date"
            label="Data Fim"
            v-model="filtro.fimSancao"
          />
        </v-col>

      </v-row>
      <v-row style="margin-left: 4px; margin-top:-15px">
        <v-col cols="12" md="3">
          <v-text-field
            v-on:keyup.enter="buscar()"
            label="CPF/CNPJ"
            v-model="filtro.cpfCnpj"
          />
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            v-on:keyup.enter="buscar()"
            label="Sancionado"
            v-model="filtro.sancionado"
          />
        </v-col>

        <v-col cols="12" md="2" style="margin-top: 1.8%">
          <v-btn style color="primary" small depressed @click="buscar()">
            <v-icon small>fa-search</v-icon>
          </v-btn>

          <v-btn
            style="margin-left: 10px"
            small
            depressed
            color="primary"
            to="/sancoes/0"
          >
            <v-icon x-small style="margin-right: 5px">fa-plus</v-icon>Novo
          </v-btn>
        </v-col>
      </v-row> -->

      <v-row>
        <v-col cols="12" md="2" style="margin-top: 1.8%">
          <v-btn
            style="margin-left: 10px"
            small
            depressed
            color="primary"
            to="/sumulas/0"
            :disabled="!userHasPermission()"
          >
            <v-icon x-small style="margin-right: 5px">fa-plus</v-icon>Novo
          </v-btn>
        </v-col>
      </v-row>

      <template>
        <v-data-table
          :headers="headers"
          :items="lista"
          :items-per-page="5"
          class="elevation-1"
          no-results-text="A busca não trouxe resultados."
          no-data-text="A busca não trouxe resultados."
        >
          <template v-slot:item.dataDiarioFormatada="{ item }">
            <span>
              {{
                item.dataDiario
                  ? $moment(item.dataDiario).format("DD/MM/YYYY")
                  : "Não Informado"
              }}
            </span>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  class="mr-2"
                  @click="editItem(item)"
                  >mdi-pencil</v-icon
                >
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="deleteItem(item)"
                  :disabled="!userAdm()"
                  >mdi-delete</v-icon
                >
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </template>

      <v-dialog :retain-focus="false" v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="headline"
            >Confirma a exclusão do item?</v-card-title
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDelete"
              >Cancelar</v-btn
            >
            <v-btn color="blue darken-1" text @click="deleteItemConfirm()"
              >OK</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </app-layout>
</template>

<script>
import sumulaService from "@/service/SumulaService";

export default {
  data() {
    return {
      deleteId: null,
      dialogDelete: false,
      filtro: {
        numeroProcesso: null,
        orgao: null,
        cpfCnpj: null,
        sancionado: null,
        inicioSancao: null,
        fimSancao: null,
      },
      lista: [],
      headers: [
        { text: "ID", value: "sumulaId", sortable: false, width: "25%" },
        { text: "Processo", value: "numeroProcesso", sortable: false },
        { text: "Ano", value: "anoProcesso", sortable: false },
        { text: "Data Diário", value: "dataDiarioFormatada", sortable: false },
        {
          text: "Ações",
          value: "actions",
          sortable: false,
          align: "center",
          width: "8%",
        },
      ],
    };
  },
  methods: {
    editItem(item) {
      this.$router.push("/sumulas/" + item.sumulaId);
    },
    deleteItem(item) {
      this.deleteId = item.sumulaId;
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      if (this.deleteId != null) {
        sumulaService.excluir(this.deleteId);
        this.deleteId = null;
        this.lista = [];
      }
      this.closeDelete();
    },
    buscar() {
      //
    },

    closeDelete() {
      this.dialogDelete = false;
      this.deleteId = null;
      this.$nextTick(() => {
        this.editedIndex = -1;
      });
    },
  },

  mounted() {
    sumulaService.findAll()
      .then((res) => (this.lista = res))
      .catch(() => (this.lista = []));
  },
  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
};
</script>

<style></style>
